import { render, staticRenderFns } from "./Archived.vue?vue&type=template&id=1cc46383&"
import script from "./Archived.vue?vue&type=script&lang=js&"
export * from "./Archived.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports